import { toast } from "react-toastify";

const ToastifyMessage = () => {
  const ToastifyHandle = (msgText, type) => {
    toast(msgText, {
      hideProgressBar: true,
      icon: false,
      autoClose: 10000,
      type: type || "success",
      position: "top-right", //top-right | top-center
      closeButton: false,
    });
  };
  return { ToastifyHandle };
};
export default ToastifyMessage;
